import $ from 'jquery';

// Keep Safari's actual input font at 16px while rendering it at 12px.
const formSelector = '#deal-form, #deal-form-purchase, #deal-form-pur-res, .trip-form';
const mobile = window.matchMedia('(max-width: 991.98px)');
const originals = new WeakMap();
let pending = false;

function restoreFields() {
  document.querySelectorAll('.compact-field-frame').forEach(frame => {
    const field = frame.firstElementChild;
    const original = originals.get(field);
    if (original === undefined) return;
    if (original === null) field.removeAttribute('style');
    else field.setAttribute('style', original);
    frame.replaceWith(field);
    originals.delete(field);
  });
}

function prepareFields() {
  if (!mobile.matches) {
    restoreFields();
    return;
  }
  document.querySelectorAll(formSelector).forEach(form => {
    form.querySelectorAll('input.form-control, textarea.form-control').forEach(field => {
      if (field.parentElement.classList.contains('compact-field-frame') ||
          /^(file|hidden|radio|checkbox|button|submit|reset|range|color)$/.test(field.type)) return;
      const rect = field.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const style = window.getComputedStyle(field);
      const frame = document.createElement('span');
      frame.className = 'compact-field-frame';
      frame.style.height = `${rect.height}px`;
      frame.style.margin = `${style.marginTop} ${style.marginRight} ${style.marginBottom} ${style.marginLeft}`;
      originals.set(field, field.getAttribute('style'));
      field.before(frame);
      frame.append(field);
      const set = (name, value) => field.style.setProperty(name, value, 'important');
      set('font-size', '16px');
      set('width', '133.333333%');
      set('min-width', '0');
      set('max-width', 'none');
      set('height', `${rect.height / 0.75}px`);
      set('min-height', `${rect.height / 0.75}px`);
      set('max-height', `${rect.height / 0.75}px`);
      set('margin', '0');
      set('transform', 'scale(0.75)');
      set('transform-origin', 'top left');
      const bookingUnderline = /^(?:deal-form|deal-form-purchase|deal-form-pur-res)$/.test(form.id) &&
        (/\[(?:name|receiver_first_name|receiver_last_name)\]$/.test(field.name) ||
          (field.classList.contains('input-border') && (field.closest('.booking-receiver-fields') || form.classList.contains('deal-edit-design'))));
      ['top', 'right', 'bottom', 'left'].forEach(side => {
        set(`padding-${side}`, `${parseFloat(style.getPropertyValue(`padding-${side}`)) / 0.75}px`);
        // Keep inline border widths free for underline validation styles.
        if (!bookingUnderline) set(`border-${side}-width`, `${parseFloat(style.getPropertyValue(`border-${side}-width`)) / 0.75}px`);
      });
      // Fixed-height notes stay scrollable inside their existing footprint.
      if (field.tagName === 'TEXTAREA') set('resize', 'none');
    });
  });
}

function scheduleFields() {
  if (pending) return;
  pending = true;
  window.requestAnimationFrame(() => {
    pending = false;
    prepareFields();
  });
}

$(scheduleFields);
$(document).on('turbolinks:load ajaxComplete cocoon:after-insert shown.bs.modal', scheduleFields);
window.addEventListener('resize', scheduleFields);
// Forms and nested rows can also arrive through native DOM updates.
const observer = new MutationObserver(scheduleFields);
$(function() { observer.observe(document.body, { childList: true, subtree: true }); });

$(document).on('turbolinks:before-cache', function() {
  observer.disconnect();
  restoreFields();
});
$(document).on('turbolinks:load', function() {
  observer.observe(document.body, { childList: true, subtree: true });
});
